export const normalizeCodeDeliveryDetails = (details) => {
  if (!details) return null;

  const deliveryMedium = details?.DeliveryMedium || details?.deliveryMedium;
  const destination = details?.Destination || details?.destination;

  if (!deliveryMedium && !destination) return null;

  return {
    deliveryMedium: deliveryMedium ? String(deliveryMedium) : null,
    destination: destination ? String(destination) : null,
  };
};

const isolateBidiText = (value) => {
  if (!value) return value;
  // Wrap dynamic LTR/RTL values with FSI/PDI so punctuation/order stays correct in mixed-direction text.
  return `\u2068${String(value)}\u2069`;
};

export const getCodeSentMessage = ({ t, codeDeliveryDetails }) => {
  const deliveryMedium = codeDeliveryDetails?.deliveryMedium;
  const destination = codeDeliveryDetails?.destination;
  const isolatedDestination = isolateBidiText(destination);

  if (deliveryMedium === 'SMS') {
    return isolatedDestination
      ? t('Authentication.Verification.codeSentSms', { destination: isolatedDestination })
      : t('Authentication.Verification.codeSentSmsUnknown');
  }

  if (deliveryMedium === 'EMAIL') {
    return isolatedDestination
      ? t('Authentication.Verification.codeSentEmail', { destination: isolatedDestination })
      : t('Authentication.Verification.codeSentEmailUnknown');
  }

  return isolatedDestination
    ? t('Authentication.Verification.codeSent', { destination: isolatedDestination })
    : t('Authentication.Verification.codeSentUnknown');
};
